
import { mapState } from 'vuex';

export default {
  name: 'LandingPageCouponsSection',
  computed: {
    ...mapState('crmLandingPage', [
      'campaignCoupons',
      'brandUserCoupons',
      'brandUserCouponsUrl'
    ]),
    coupons() {
      return [
        ...this.brandUserCoupons.map(coupon => ({
          name: coupon.coupon_name,
          expires_at: coupon.expires_at,
          image_url: this.DEFAULT_COUPON_IMAGE_URL,
          url: this.brandUserCouponsUrl
        })),
        ...this.campaignCoupons.map(coupon => ({
          name: coupon.name,
          expires_at: coupon.end_at,
          image_url: coupon.image_url,
          url: coupon.url
        }))
      ];
    }
  },
  created() {
    this.DEFAULT_COUPON_IMAGE_URL =
      'https://assets.cre.ma/m/m/target/default_coupon_image.png';
  },
  methods: {
    redirectTo(url) {
      if (!url) return;

      window.location.href = url;
    }
  }
};
